import { Component, inject, OnInit } from '@angular/core';
import { LFProject } from '@lfw/roesberg.liveforms.core';
import { LfwRouterService } from '../../route/lfw-router.service';
import { SelectionType } from '../../shared/enums/selection-type';
import { SelectionArguments } from '../../shared/models/selection-arguments';
import { InfoService } from '../../shared/services/info.service';
import { ProjectListViewComponent } from '../components/project-list-view/project-list-view.component';
import { ProjectsService } from '../projects.service';

@Component({
  selector: 'lfw-project-page',
  templateUrl: './project-page.component.html',
  styleUrl: './project-page.component.css',
  imports: [ProjectListViewComponent]
})
export class ProjectPageComponent implements OnInit {
  projects?: LFProject[] = undefined;

  private readonly projectService = inject(ProjectsService);
  private readonly infoService = inject(InfoService);
  private readonly lfwRouterService = inject(LfwRouterService);

  ngOnInit(): void {
    this.projectService.allProjects$.subscribe((res) => {
      this.projects = res;
      this.infoService.setLoadedItems(this.projects.length);
    });
  }

  onProjectSelected(args: SelectionArguments): void {
    if (args != undefined && args.action === SelectionType.Selected) {
      this.projectService.selectProject(args.id).subscribe((res) => {
        if (res) {
          this.lfwRouterService.navigateToOrdersRoot();
        } else {
          this.lfwRouterService.errorStop('PROJECTSELECTERROR');
        }
      });
    }
  }
}
